exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CreateOpeningTicketPurposePanel-defaultContent-gb7vY h4{margin:20px 0;text-align:center;text-transform:uppercase;font-weight:400}.CreateOpeningTicketPurposePanel-defaultContent-gb7vY h5{margin:20px 0;font-weight:400;text-transform:uppercase}.CreateOpeningTicketPurposePanel-category-1QDox{position:relative}.CreateOpeningTicketPurposePanel-category-1QDox small{position:absolute;top:14px;right:-10px;font-size:16px;font-weight:400}.CreateOpeningTicketPurposePanel-categorySection-1I22z{margin-bottom:15px;border-bottom:1px solid #dadada}.CreateOpeningTicketPurposePanel-manage-3cTZB{margin:10px;text-align:center}.CreateOpeningTicketPurposePanel-manage-3cTZB a{font-weight:400;color:#00e5ce}.CreateOpeningTicketPurposePanel-info-1SauA{display:inline-block;float:right;min-width:22px;padding:4px 0 2px;border:1px solid #00e5ce;border-radius:11px;line-height:1;text-align:center;font-size:14px;font-weight:400;color:#00e5ce}", ""]);

// exports
exports.locals = {
	"defaultContent": "CreateOpeningTicketPurposePanel-defaultContent-gb7vY",
	"category": "CreateOpeningTicketPurposePanel-category-1QDox",
	"categorySection": "CreateOpeningTicketPurposePanel-categorySection-1I22z",
	"manage": "CreateOpeningTicketPurposePanel-manage-3cTZB",
	"info": "CreateOpeningTicketPurposePanel-info-1SauA"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/reference/components/CreateOpeningTicketPurposePanel.less
// module id = 1734
// module chunks = 0